const STORAGE_PREFIX = 'kilo_briefing_read_'

function storageKey(key: string): string {
  return `${STORAGE_PREFIX}${key}`
}

export function isBriefingRead(key: string): boolean {
  try {
    return localStorage.getItem(storageKey(key)) === '1'
  } catch {
    return false
  }
}

export function markBriefingRead(key: string): void {
  try {
    localStorage.setItem(storageKey(key), '1')
  } catch {
    /* ignore quota / private mode */
  }
}

export function briefingKeyMorning(date: string): string {
  return `morning_${date}`
}

export function briefingKeyNutrition(date: string): string {
  return `nutrition_${date}`
}

export const BRIEFING_KEY_CALENDAR_HINT = 'calendar_hint'
export const BRIEFING_KEY_STRESS_FOOTPRINT = 'stress_footprint'
